import React, { useState, useRef } from 'react';
import { Select, Spin, message } from 'antd';
import api from '../../../services/api';

const DEBOUNCE_DELAY = 500; // ms
const API_TIMEOUT = 7000; // ms

function SearchNcm({ value, onChange }) {
  const [options, setOptions] = useState([]);
  const [fetching, setFetching] = useState(false);
  const debounceTimer = useRef(null);
  const cache = useRef({}); // cache de buscas já feitas

  // Busca com timeout
  const fetchOptions = (inputValue) => {
    if (!inputValue) {
      setOptions([]);
      return;
    }

    // Verifica cache
    if (cache.current[inputValue]) {
      setOptions(cache.current[inputValue]);
      return;
    }

    setFetching(true);
    const controller = new AbortController();
    const timeoutId = setTimeout(() => {
      controller.abort();
      setFetching(false);
      message.error('Tempo de resposta excedido. Tente novamente.');
    }, API_TIMEOUT);

    api
      .get('/hs-mercadoria', {
        params: { q: inputValue },
        signal: controller.signal,
      })
      .then((response) => {
        const opts = (response.data || []).map((item) => ({
          label: `${item.hscode} - ${item.description}`,
          value: item.hscode,
          item,
        }));
        setOptions(opts);
        cache.current[inputValue] = opts; // Salva cache
      })
      .catch((err) => {
        if (err.name !== 'CanceledError') {
          setOptions([]);
        }
      })
      .finally(() => {
        clearTimeout(timeoutId);
        setFetching(false);
      });
  };

  // Debounced search
  const handleSearch = (inputValue) => {
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }
    debounceTimer.current = setTimeout(() => fetchOptions(inputValue), DEBOUNCE_DELAY);
  };

  return (
    <div className="col-md-12">
      <Select
        showSearch
        allowClear
        value={value}
        placeholder="HS Code"
        filterOption={false}
        onSearch={handleSearch}
        onChange={onChange}
        notFoundContent={fetching ? <Spin size="small" /> : null}
        style={{ width: '100%' }}
        options={options}
      />
    </div>
  );
}

export default SearchNcm;
